package de.oevbs.kunde.kundenportal2.authentication

enum class PortalAuthority(val value: String) {
    None("NONE"),
    Registered("KUPLA_REGISTERED"),
    CrmAuthenticated("KUPLA_CRMAUTHED"),
    PinAuthenticated("KUPLA_PINAUTHED")
}